import React from 'react'
import { PurchaseOrderPage } from './purchase-order-page'

export const PurchaseOrderPageApprove = () => {
  return <PurchaseOrderPage pageType={2} />;
};
